import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MessageInterface } from './message-interface.model';

export interface MessagesState extends EntityState<MessageInterface> {
    hasMore: boolean;
    page: number;
}

const initialState: MessagesState = {
    hasMore: true,
    page: 1
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'discussion-list-item', resettable: true })
export class MessagesStore extends EntityStore<MessagesState, MessageInterface> {

    constructor() {
        super(initialState);
    }

    public updatePage(page: { hasMore: boolean; page: number }) {
        this.update(page);
    }
}
